<!--选择城市-->
<template>
  <div class="select-city">
    <span
      tabindex="0"
      hidefocus="true"
      class="selectButton"
      @click.stop="showCity"
      :class="{ noAllow: $route.matched[1].meta.title.includes('排行榜')||$route.meta.title==='网速地图'}"
    >
      {{ $store.state.city }}
      <!-- <img
        :class="{'city-row-ani':cityShow}"
        src="@/assets/images/row-down.svg"
        alt="down"
      /> -->
    </span>
    <transition name="el-zoom-in-top">
      <div
        class="select-city-modal"
        v-show="cityShow"
        @click.stop=""
      >
        <div class="base-modal select-city-content">
          <dl
            v-for="item in cityList"
            :key="item.title"
          >
            <dt :class="{ hide: item.title == 'repetition' }">
              {{ item.title }}
            </dt>
            <dd
              v-for="cityItem in item.city"
              :key="cityItem"
              @click="changeCity(cityItem)"
              :class="{ 'active': cityItem === $store.state.city,'china':['中国澳门','中国香港','中国台湾','中国新疆','中国西藏'].includes(cityItem) }"
            >
              {{ cityItem }}
            </dd>
          </dl>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'SelectCity',
  data() {
    return {
      cityShow: false, // 是否展示模态框
      cityList: [
        {
          title: '全部地区',
          city: ['全国']
        },
        {
          title: '华北地区',
          city: ['北京', '天津', '河北', '山西', '内蒙古']
        },
        {
          title: '东北地区',
          city: ['辽宁', '吉林', '黑龙江']
        },
        {
          title: '华东地区',
          city: ['上海', '江苏', '浙江', '山东', '安徽']
        },
        {
          title: '华中地区',
          city: ['湖北', '湖南', '江西', '河南']
        },
        {
          title: '华南地区',
          city: ['广东', '广西', '海南', '福建']
        },
        {
          title: '西南地区',
          city: ['四川', '重庆', '贵州', '云南', '中国西藏']
        },
        {
          title: '西北地区',
          city: ['陕西', '甘肃', '中国新疆', '青海', '宁夏']
        },

        {
          title: '特别行政区',
          city: ['中国香港', '中国澳门', '中国台湾']
        }
        // {
        //   title: "repetition",
        //   // city: ["福建", "江西", "中国台湾"]
        //   city: ["福建", "江西"]
        // },
        // {
        //   title: "东北地区",
        //   city: ["辽宁", "吉林", "黑龙江"]
        // },
      ] // 城市列表
    }
  },
  methods: {
    /**
     * 改变弹出框的方法
     * @param {boolean|string} bool
     * **/
    toggleModal(bool) {
      this.cityShow = bool === 'toggle' ? !this.cityShow : bool
    },
    /**
     * 修改城市名称
     * @param {string} cityName
     * **/
    changeCity(cityName) {
      this.$store.dispatch('changeCity', cityName)
      this.toggleModal(false)
    },
    closeCity() {
      setTimeout(() => {
        this.cityShow = false
      }, 200)
    },
    showCity() {
      if (this.$route.matched[1].meta.title.includes('排行榜') || this.$route.meta.title === '网速地图') {
        return false
      }
      if (!this.is_login) {
        this.$loginDialog.open()
        return false
      }
      if (!this.is_member) {
        //debugger
        //非会员不管你登录没登录
        //if (this.$route.meta.title === '信号热力图') {
          this.$msgBox
            .showMsgBox({
              content: '开通测速网大数据会员，可查看近3个月平台页面展示的所有数据',
              cancelVal: '我再想想',
              confirmVal: '立即开通'
            })
            .then(async val => {
              // ...
              this.$router.push({ path: '/pay-member' })
            })
            .catch(() => {
              // ...
              console.log('取消')
            })
          return false
        }
      //}
      setTimeout(() => {
        this.cityShow = true
      }, 200)
    }
  },
  mounted() {
    // document.getElementsByClassName('selectButton')[0].onblur = this.closeCity
    //document.getElementsByClassName('selectButton')[0].onfocus = this.showCity
    let app = document.getElementById('app')
    app.addEventListener(
      'click',
      () => {
        this.closeCity()
      },
      true
    )
  },
  computed: {
    ...mapState('login', ['is_login', 'is_member'])
  }
}
</script>

<style scoped lang="less">
.selectButton {
  outline: 0;
}
.hide {
  opacity: 0;
}
.select-city {
  width: 1.43rem;
  font-size: 0.12rem;
  z-index: 999999;
  position: relative;
  // cursor: pointer;

  & > span {
    width: 1.42rem;
    height: 0.44rem;
    // background: rgba(32, 199, 242, 1);
    background-image: url('@/assets/image/layout/nav_select_city.png'), url('@/assets/image/layout/row_down.png');
    background-repeat: no-repeat, no-repeat;
    background-position: left top, 0.82rem 0.14rem;
    background-size: 1.42rem 0.44rem, 0.16rem 0.16rem;
    // border-radius: 0.15rem;
    cursor: pointer;
    color: rgba(255, 255, 255, 1);
    font-size: 0.16rem;
    display: flex;
    padding: 0.15rem 0 0 0.16rem;
    // justify-content: center;
    // align-items: center;
    font-weight: 500;
    color: #82ebff;
    box-sizing: border-box;
    // img {
    //   margin-left: 0.12rem;
    //   transition: all 0.6s;

    //   &.city-row-ani {
    //     transform: rotate(180deg);
    //   }
    // }
  }
  & > span.noAllow {
    cursor: not-allowed;
  }
}

.select-city-content {
  position: absolute;
  left: calc(50% - 3.5rem);
  bottom: -3.58rem;
  width: 4.84rem;
  height: 3.5rem;
  background-color: rgba(11, 25, 66, 0.9);
  border: 1px solid #00d2fa;
  box-sizing: border-box;
  padding: 0.2rem 0 0 0.3rem;
  z-index: 2014;
  background-origin: padding-box;

  dl {
    margin-bottom: 0.16rem;
    overflow: hidden;

    dt {
      font-weight: 500;
      font-size: 0.14rem;
      color: #b8b8b8;
      width: 0.8rem;
      float: left;
      margin-right: 0.08rem;
      line-height: 0.2rem;
    }

    dd {
      text-align: left;
      float: left;
      // min-width: 0.56rem;
      width: auto;
      height: 0.2rem;
      line-height: 0.2rem;
      border-radius: 0.13rem;
      font-size: 0.14rem;
      margin-right: 0.3rem;
      cursor: pointer;
      color: #ffffff;
      font-weight: 400;
      &.active {
        padding: 0 0.05rem;
        box-sizing: border-box;
        background: #06c6f1;
        margin-left: -.05rem;
        margin-right: .25rem;
      }
      &.china {
        margin-right: 0.2rem;
      }
    }
  }
}

// @media screen and (min-width: 900px) and (max-width: 1350px) {
//     .select-city {
//        & > span {

//       }
//     }
// }
</style>
